import {IPropiedadesForma} from "../../interfaces/IPropiedadesForma";
import {enums} from "../../enums/enums";
import AutocompleteControl, { IClienteSku } from "../../components/controls/AutocompleteControl";

export interface IMercancia extends IPropiedadesForma {
    cantidad?: number
    embalajeId?: number
    embalaje?: any
    alto?: number | null
    altoReal?: number | null
    largo?: number | null
    ancho?: number | null
    peso?: number | null
    volumen?: number | null
    esEstibable: boolean
    camposHabilitados: boolean
    camposParaValidar?: string[]
    etiquetaEmbalaje?: any,
    skuSeleccionado?: IClienteSku | null;
    skuID?: number | null;
    disabled?:  boolean | false;
}

const camposParaValidar: string[] = ['alto', 'largo', 'ancho', 'peso'];

export class Mercancia {
    constructor(props: IMercancia) {
        Object.assign(this, props);
        this.esFormaValida = true;
        this.camposInvalidos = [];
        this.camposParaValidar = camposParaValidar;
    }

    CalcularVolumen(unidadMedidaId: number, metrosPulgada: number) {
        const cantidad = this.cantidad || 0;
        const alto = this.alto || 0;
        const largo = this.largo || 0;
        const ancho = this.ancho || 0;

        if (cantidad > 0 && alto > 0 && largo > 0 && ancho > 0) {
            this.volumen = (cantidad * alto * largo * ancho);
            this.volumen = parseFloat(this.volumen.toFixed(3));
        }

        if (unidadMedidaId === enums.unidadMedidaLongitud.pulgadas) {
            //this.volumen = (this.volumen || 0 / 61023.6879527737);
            this.volumen = (cantidad *  parseFloat((alto / metrosPulgada).toFixed(3))  * parseFloat((largo / metrosPulgada).toFixed(3)) * parseFloat((ancho / metrosPulgada).toFixed(3))  );
            this.volumen = parseFloat(this.volumen.toFixed(3));
        }
    }

    LimpiarCampos(campoModificado: string) {
        if (campoModificado === "embalajeId" || campoModificado === "sistemaId")
            this.camposParaValidar?.forEach(campo => {
                this[campo] = null
            });
    }

    ConvertirValores(nombreUnidad: string, unidadMedidaId: number, metroPulgada: number, kiloLibra: number) {
        if (nombreUnidad === "unidadMedidaPesoId") {
            const multiplicar = unidadMedidaId === enums.unidadMedidaPeso.libras;
            this.ConvertirValor("peso", kiloLibra, multiplicar);
        } else {
            const multiplicar = unidadMedidaId === enums.unidadMedidaLongitud.pulgadas;
            this.ConvertirValor("alto", metroPulgada, multiplicar);
            this.ConvertirValor("largo", metroPulgada, multiplicar);
            this.ConvertirValor("ancho", metroPulgada, multiplicar);
        }
    }

    ObtenerDeCotizacion(mercancia, esCotizacion) {
        if(esCotizacion)
            this.id = mercancia.cotizacionMercanciaID;
        else
            this.id = mercancia.solicitudMercanciaID;
        this.embalaje = mercancia.embalaje;
        this.embalajeId = mercancia.embalajeID;
        this.largo = mercancia.largo;
        this.alto = mercancia.alto;
        this.altoReal = mercancia.alto;
        this.ancho = mercancia.ancho;
        this.cantidad = mercancia.cantidad;
        this.esEstibable = mercancia.esNoEstibable;
        this.peso = mercancia.peso;
        this.volumen = mercancia.volumen;
        this.etiquetaEmbalaje = mercancia.etiquetaEmbalaje;
        this.skuSeleccionado = mercancia.skuSeleccionado;
        this.skuID = mercancia.skuID;
        this.disabled = mercancia.skuID > 0 ? true: false;
    }

    private ConvertirValor(propiedad: string, valorConversion: number, multiplicar: boolean) {
        const valor = this[propiedad] || 0;
        if (this[propiedad]) {
            this[propiedad] = multiplicar ? this[propiedad] * valorConversion : this[propiedad] / valorConversion;
        }
    }
}

export interface Mercancia extends IMercancia {
}
